// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__38zUG","inner":"Header_inner__mrlUv","link":"Header_link__WQt02","linkLabel":"Header_linkLabel__XtLA+"};